(function () {
  function getProductsPerPage(section) {
    if (window.matchMedia("(max-width: 720px)").matches) return 4;
    if (window.matchMedia("(max-width: 980px)").matches) return 6;
    return Number(section.dataset.bocaCardsPerPage || 8);
  }

  function initBocaProductGuide(section) {
    if (!section || section.dataset.bocaInitialized === "true") return;
    section.dataset.bocaInitialized = "true";

    const cards = Array.from(section.querySelectorAll("[data-boca-card]"));
    const status = section.querySelector("[data-boca-status]");
    const emptyState = section.querySelector("[data-boca-empty]");
    const filterButtons = Array.from(section.querySelectorAll(".boca-product-guide__filters [data-boca-route]"));
    const prevButton = section.querySelector("[data-boca-prev]");
    const nextButton = section.querySelector("[data-boca-next]");
    let activeRoute = "all";
    let productPage = 0;

    function getFilteredCards() {
      return activeRoute === "all" ? cards : cards.filter(function (card) {
        return card.dataset.bocaRoute === activeRoute;
      });
    }

    function renderProducts() {
      const perPage = getProductsPerPage(section);
      const filtered = getFilteredCards();
      const maxPage = Math.max(0, Math.ceil(filtered.length / perPage) - 1);
      productPage = Math.min(productPage, maxPage);
      const visible = new Set(filtered.slice(productPage * perPage, productPage * perPage + perPage));

      cards.forEach(function (card) {
        card.hidden = !visible.has(card);
      });

      if (emptyState) emptyState.hidden = filtered.length > 0;
      if (status) status.textContent = "Page " + (productPage + 1) + " / " + (maxPage + 1);
      if (prevButton) prevButton.disabled = productPage === 0;
      if (nextButton) nextButton.disabled = productPage === maxPage;
    }

    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        filterButtons.forEach(function (item) {
          item.classList.remove("is-active");
        });
        button.classList.add("is-active");
        activeRoute = button.dataset.bocaRoute;
        productPage = 0;
        renderProducts();
      });
    });

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        productPage = Math.max(0, productPage - 1);
        renderProducts();
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        const maxPage = Math.max(0, Math.ceil(getFilteredCards().length / getProductsPerPage(section)) - 1);
        productPage = Math.min(maxPage, productPage + 1);
        renderProducts();
      });
    }

    window.addEventListener("resize", function () {
      productPage = 0;
      renderProducts();
    });

    renderProducts();
  }

  function initAllBocaProductGuides(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll
      ? scope.querySelectorAll("[data-boca-product-guide]")
      : [];
    sections.forEach(initBocaProductGuide);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllBocaProductGuides(document);
    });
  } else {
    initAllBocaProductGuides(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllBocaProductGuides(event.target);
  });
})();
